import { type DocumentConfig } from '@alpod-ai-writer/shared';

export enum DocumentTypeLabel {
    BakalarskaPrice = 'Bakalářská práce',
    DiplomovaPrice = 'Diplomová práce',
}

const DOCUMENT_TYPE_PRIORITY: Partial<Record<DocumentTypeLabel, number>> = {
    [DocumentTypeLabel.BakalarskaPrice]: 0,
    [DocumentTypeLabel.DiplomovaPrice]: 1,
};

export function sortedDocumentTypeKeys(types: DocumentConfig['types']): string[] {
    return Object.keys(types).sort((a, b) => {
        const ap = DOCUMENT_TYPE_PRIORITY[types[a].label as DocumentTypeLabel] ?? Infinity;
        const bp = DOCUMENT_TYPE_PRIORITY[types[b].label as DocumentTypeLabel] ?? Infinity;
        return ap - bp;
    });
}
